import React, { useState, useRef, useEffect } from "react";
import {
  Upload,
  X,
  File as FileIcon,
  Image,
  FileText,
  Film,
  Download,
} from "lucide-react";

export const FileInput = ({ onSubmit }) => {
  const [file, setFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(false);
  const [hoveredRemove, setHoveredRemove] = useState(null);
  const [hoveredDownload, setHoveredDownload] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetch("/DemoFile.xlsx")
      .then((res) => res.blob())
      .then((blob) => {
        const f = new File([blob], "DemoFile.xlsx", {
          type: blob.type,
        });
        setFile(f);
      });
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    addFiles(droppedFiles);
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    addFiles(selectedFiles);
  };

  const addFiles = (newFile) => {
    setFile((prev) => [newFile]);
  };

  const removeFile = () => {
    setFile(null);
  };

  const downloadFile = () => {
    const link = document.createElement("a");
    link.href = "./DemoFile.xlsx";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFileIcon = (fileType) => {
    if (fileType.startsWith("image/"))
      return <Image style={{ width: "1.25rem", height: "1.25rem" }} />;
    if (fileType.startsWith("video/"))
      return <Film style={{ width: "1.25rem", height: "1.25rem" }} />;
    if (fileType.includes("pdf") || fileType.includes("document"))
      return <FileText style={{ width: "1.25rem", height: "1.25rem" }} />;
    return <FileIcon style={{ width: "1.25rem", height: "1.25rem" }} />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  };

  return (
    <div
      style={{
        padding: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ width: "100%", maxWidth: "42rem" }}>
        <p
          style={{
            color: "#6b7280",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          Перетяните файл или кликните для выбора
        </p>

        <div
          // onDragOver={handleDragOver}
          // onDragLeave={handleDragLeave}
          // onDrop={handleDrop}
          // onClick={() => fileInputRef.current?.click()}
          style={{
            position: "relative",
            border: isDragging ? "3px dashed #0078FF" : "3px dashed #0078FF",
            borderRadius: "1rem",
            padding: "3rem",
            transition: "all 0.3s",
            cursor: "pointer",
            backgroundColor: isDragging ? "#faf5ff" : "#ffffff",
            boxShadow: isDragging
              ? "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
              : "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            transform: isDragging ? "scale(1.05)" : "scale(1)",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            disabled
            onChange={handleFileChange}
            style={{ display: "none" }}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                marginBottom: "1rem",
                padding: "1rem",
                borderRadius: "9999px",
                backgroundColor: isDragging ? "#e9d5ff" : "#f3e8ff",
                transition: "all 0.3s",
                transform: isDragging ? "scale(1.1)" : "scale(1)",
              }}
            >
              <Upload
                style={{
                  width: "3rem",
                  height: "3rem",
                  color: isDragging ? "#0078FF" : "#0078FF",
                  transition: "color 0.3s",
                }}
              />
            </div>

            <h3
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                color: "#0078FF",
                marginBottom: "0.5rem",
              }}
            >
              {isDragging
                ? "Перетяните файл в эту зону"
                : "Выберите файл или перетащите его в эту зону"}
            </h3>
            <p
              style={{
                color: "#6b7280",
                fontSize: "0.875rem",
              }}
            >
              Поддерживаются файлы .xlsx и .csv
            </p>
          </div>
        </div>

        {file && (
          <div style={{ marginTop: "2rem" }}>
            <h3
              style={{
                fontSize: "1.125rem",
                fontWeight: "600",
                color: "#374151",
                marginBottom: "1rem",
              }}
            >
              Выбранный файл:
            </h3>
            <div
              onMouseEnter={() => setHoveredItem(1)}
              onMouseLeave={() => setHoveredItem(null)}
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
                padding: "1rem",
                boxShadow:
                  hoveredItem === 1
                    ? "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
                    : "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                transition: "box-shadow 0.3s",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginBottom: "0.75rem",
              }}
            >
              <div
                style={{
                  width: "4rem",
                  height: "4rem",
                  background:
                    "linear-gradient(135deg, #f3e8ff 0%, #fce7f3 100%)",
                  borderRadius: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#0078FF",
                }}
              >
                {getFileIcon(file.type)}
              </div>

              <div style={{ flex: "1", minWidth: "0" }}>
                <p
                  style={{
                    fontWeight: "500",
                    color: "#1f2937",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {file.name}
                </p>
                <p
                  style={{
                    fontSize: "0.875rem",
                    color: "#6b7280",
                  }}
                >
                  {formatFileSize(file.size)}
                </p>
              </div>

              <button
                onClick={() => downloadFile(1)}
                onMouseEnter={() => setHoveredDownload(1)}
                onMouseLeave={() => setHoveredDownload(null)}
                style={{
                  padding: "0.5rem",
                  borderRadius: "9999px",
                  transition: "all 0.2s",
                  backgroundColor:
                    hoveredDownload === 1 ? "#fef2f2" : "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: hoveredDownload === 1 ? "#ef4444" : "#9ca3af",
                }}
              >
                <Download style={{ width: "1.25rem", height: "1.25rem" }} />
              </button>

              <button
                // onClick={() => removeFile(1)}
                onMouseEnter={() => setHoveredRemove(1)}
                onMouseLeave={() => setHoveredRemove(null)}
                style={{
                  padding: "0.5rem",
                  borderRadius: "9999px",
                  transition: "all 0.2s",
                  backgroundColor:
                    hoveredRemove === 1 ? "#fef2f2" : "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: hoveredRemove === 1 ? "#ef4444" : "#9ca3af",
                }}
              >
                <X style={{ width: "1.25rem", height: "1.25rem" }} />
              </button>
            </div>

            <button
              onClick={onSubmit}
              onMouseEnter={() => setHoveredButton(true)}
              onMouseLeave={() => setHoveredButton(false)}
              style={{
                width: "100%",
                marginTop: "1.5rem",
                background: "#0078FF",
                color: "#ffffff",
                padding: "1rem",
                borderRadius: "0.75rem",
                fontWeight: "600",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s",
                boxShadow: hoveredButton
                  ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                  : "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                transform: hoveredButton ? "scale(1.02)" : "scale(1)",
              }}
            >
              Начать Анализ
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
